import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { useTranslation } from "react-i18next";

const FounderCard = ({ founder }) => {
  const { t } = useTranslation();
  const handleWhatsAppClick = () => {
    const phoneNumber = founder.phone.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    const message = encodeURIComponent(founder.whatsappMessage);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${founder.phone}`;
  };

  const handleLinkedInClick = () => {
    window.open(founder.linkedin, "_blank");
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${founder.email}`;
  };

  const handleSaveContact = () => {
    // Create vCard data with proper name formatting
    const nameParts = founder.name.split(" ");
    const lastName = nameParts[nameParts.length - 1];
    const firstName = nameParts.slice(0, -1).join(" ");

    const vCard = `BEGIN:VCARD
VERSION:3.0
FN:${founder.name}
N:${lastName};${firstName};;;
ORG:Cus-Pro
TITLE:${founder.title}
TEL:${founder.phone}
EMAIL:${founder.email}
URL:${founder.linkedin}
END:VCARD`;

    // Create and download vCard file
    const blob = new Blob([vCard], { type: "text/vcard" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${founder.name.replace(/\s+/g, "_")}_Contact.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Card className="founder-card h-100">
      <Card.Body className="d-flex flex-column">
        {/* Founder Photo */}
        <div className="founder-photo-container text-center mb-4">
          <Image
            src={founder.photo}
            alt={founder.name}
            className="founder-photo"
            onError={(e) => {
              // Fallback to a default avatar if image fails to load
              e.target.src =
                "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='150' height='150' viewBox='0 0 150 150'%3E%3Ccircle cx='75' cy='75' r='75' fill='%23e9ecef'/%3E%3Ctext x='75' y='85' font-family='Arial' font-size='60' fill='%236c757d' text-anchor='middle'%3E👤%3C/text%3E%3C/svg%3E";
            }}
          />
        </div>

        {/* Founder Info */}
        <div className="founder-info text-center mb-4">
          <h4 className="founder-name">{founder.name}</h4>
          <p className="founder-title">{founder.title}</p>
          <p className="founder-bio">{founder.bio}</p>
        </div>

        {/* Contact Information */}
        <div className="contact-info mb-4">
          <div className="contact-item">
            <strong>{t("landing.founders.card.phone")}:</strong> {founder.phone}
          </div>
          {founder.email && (
            <div className="contact-item">
              <strong>{t("landing.founders.card.email")}:</strong>
              <a href={`mailto:${founder.email}`} className="ms-2">
                {founder.email}
              </a>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="action-buttons mt-auto">
          <Row className="g-2">
            <Col xs={6}>
              <Button variant="success" className="w-100 whatsapp-btn" onClick={handleWhatsAppClick}>
                <i className="fab fa-whatsapp me-2"></i>
                {t("landing.founders.card.whatsappButton")}
              </Button>
            </Col>
            <Col xs={6}>
              <Button variant="primary" className="w-100 phone-btn" onClick={handlePhoneClick}>
                <i className="fas fa-phone me-2"></i>
                {t("landing.founders.card.callButton")}
              </Button>
            </Col>
            <Col xs={6}>
              <Button variant="info" className="w-100 linkedin-btn" onClick={handleLinkedInClick}>
                <i className="fab fa-linkedin me-2"></i>
                {t("landing.founders.card.linkedinButton")}
              </Button>
            </Col>
            <Col xs={6}>
              <Button variant="warning" className="w-100 email-btn" onClick={handleEmailClick}>
                <i className="fas fa-envelope me-2"></i>
                {t("landing.founders.card.emailButton")}
              </Button>
            </Col>
            <Col xs={12}>
              <Button variant="outline-secondary" className="w-100 save-btn" onClick={handleSaveContact}>
                <i className="fas fa-download me-2"></i>
                {t("landing.founders.card.saveContactButton")}
              </Button>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

export default FounderCard;
